import { jsx as t, jsxs as p, Fragment as z } from "react/jsx-runtime";
import q, { createElement as F } from "react";
import { c as S } from "./extends-2c39a7b4.js";
import { B as v } from "./pp-react-text.esm-fc0bee1c.js";
import { G as g, C as A, H as w } from "./helpers-7c298f27.js";
import { C as M } from "./ContentRenderer-b6eef314.js";
import { d as O, e as Z, a as L, C as y, R as N } from "./getButtonHref-4b514703.js";
import { I as P } from "./Image-ad475371.js";
import { V as J } from "./Button-ac33fe97.js";
import { w as K } from "./propsChecker-7de44c11.js";
import { u as Q } from "./Parent-2cc4d070.js";
import "./pp-react-theme.esm-ef1d004f.js";
import "./pp-react-utils.esm-093ddd7e.js";
import "./LazyLoad-41f8370a.js";
import "./pp-react-icons.esm-6f29efc7.js";
var f = /* @__PURE__ */ ((r) => (r["Blue 400"] = "Blue 400", r["Blue 700"] = "Blue 700", r["Grey 400"] = "Grey 400", r["Green 400"] = "Green 400", r["Purple 400"] = "Purple 400", r.White = "White", r["Yellow 400"] = "Yellow 400", r))(f || {});
const X = {
  [g.sm]: 12,
  [g.md]: 12,
  [g.lg]: 12
}, ee = {
  [g.sm]: 12,
  [g.md]: 6,
  [g.lg]: 4
};
var T = /* @__PURE__ */ ((r) => (r["SMB grid"] = "SMB grid", r["SMB grid grey"] = "SMB grid grey", r))(T || {});
const a = { ...A, ...T }, re = "_bgColorYellow400_ui2kt_1", te = "_bgColorGreen400_ui2kt_4", oe = "_bgColorPurple400_ui2kt_7", ae = "_bgColorGrey400_ui2kt_10", ne = "_bgColorBlue400_ui2kt_13", ie = "_bgColorBlue700_ui2kt_16", se = "_bgColorWhite_ui2kt_19", le = "_SMBCard_ui2kt_29", de = "_LECard_ui2kt_30", ce = "_topContainer_ui2kt_36", Ce = "_headline_ui2kt_47", me = "_imageContainer_ui2kt_56", ge = "_bottomContainer_ui2kt_71", _e = "_paragraph_ui2kt_80", ue = "_SMBGRIDCard_ui2kt_171", pe = "_SECURITYCENTERCard_ui2kt_230", he = "_SECURITYCENTERV2Card_ui2kt_231", Re = "_SMBGRIDGREYCard_ui2kt_234", ke = "_SMBGRIDGREYV2Card_ui2kt_235", Ie = "_chevron_ui2kt_286", be = "_cardCol_ui2kt_353", Be = "_cardItemRowImagePosLeft_ui2kt_422", Se = "_cardItemRowImagePosRight_ui2kt_427", o = {
  bgColorYellow400: re,
  bgColorGreen400: te,
  bgColorPurple400: oe,
  bgColorGrey400: ae,
  bgColorBlue400: ne,
  bgColorBlue700: ie,
  bgColorWhite: se,
  SMBCard: le,
  LECard: de,
  topContainer: ce,
  headline: Ce,
  imageContainer: me,
  bottomContainer: ge,
  paragraph: _e,
  SMBGRIDCard: ue,
  SECURITYCENTERCard: pe,
  SECURITYCENTERV2Card: he,
  SMBGRIDGREYCard: Re,
  SMBGRIDGREYV2Card: ke,
  chevron: Ie,
  cardCol: be,
  cardItemRowImagePosLeft: Be,
  cardItemRowImagePosRight: Se
}, fe = "CardItem", Y = ({
  className: r = "",
  headline: s = "",
  imageUrl: n = "",
  imageAltText: C = "",
  backgroundColor: l = f["Yellow 400"],
  paragraph: d = "",
  cta: e,
  leftPosition: R = !0,
  analyticsCompName: _ = "Card",
  theme: c = a.SMB,
  headlineTagName: k = "h3",
  isGridV2: I = !1,
  ...h
}) => {
  const { environment: { pageSegment: b = "" } = {} } = Q(), u = [
    a["SMB grid"],
    a["SMB grid grey"],
    a.SecurityCenter
  ].includes(c), i = c === a["SMB grid grey"] || c === a.SecurityCenter, B = I ? "v2" : "", V = `bgColor${l.replace(" ", "")}`, H = !!e || !!d, j = `${(c + B).split(" ").join("").toUpperCase()}Card`, D = !u && (R ? o.cardItemRowImagePosLeft : o.cardItemRowImagePosRight), $ = !i && o[V], E = e && i ? "a" : "div", U = u ? ee : X, G = {
    className: o[j],
    href: e == null ? void 0 : e.url,
    target: e == null ? void 0 : e.target
  };
  return E === "a" && (G["data-pa-click"] = O(
    {
      componentName: _,
      linkText: e.text,
      linkType: e.type,
      clickEvent: e.clickEventName
    },
    b,
    Z.CTA
  )), /* @__PURE__ */ t(
    L,
    {
      ...h,
      ...U,
      className: S(D, o.cardCol, r),
      children: q.createElement(
        E,
        G,
        /* @__PURE__ */ p(z, { children: [
          /* @__PURE__ */ p("div", { className: S(o.topContainer, $), children: [
            /* @__PURE__ */ t(v, { as: k, className: o.headline, children: s }),
            n && !i && /* @__PURE__ */ t(
              P,
              {
                src: n,
                alt: C,
                lazyLoad: !0,
                dimensions: {
                  minHeight: "240px",
                  minWidth: "auto"
                },
                className: o.imageContainer
              }
            ),
            e && i && /* @__PURE__ */ t("span", { className: o.chevron, children: /* @__PURE__ */ t(
              "svg",
              {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /* @__PURE__ */ t(
                  "path",
                  {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M8.29289 5.29289C7.90237 5.68342 7.90237 6.31658 8.29289 6.70711L13.5852 11.9994L8.29348 17.2823C7.90263 17.6725 7.90211 18.3057 8.2923 18.6965C8.6825 19.0874 9.31567 19.0879 9.70652 18.6977L15.7058 12.7084C15.7059 12.7083 15.7065 12.7077 15 12L15.7058 12.7084C15.8936 12.5209 15.9999 12.2658 16 12.0004C16.0001 11.7351 15.8947 11.4805 15.7071 11.2929L9.70711 5.29289C9.31658 4.90237 8.68342 4.90237 8.29289 5.29289Z",
                    fill: "#515354"
                  }
                )
              }
            ) })
          ] }),
          H && /* @__PURE__ */ p("div", { className: o.bottomContainer, children: [
            n && i && /* @__PURE__ */ t(
              P,
              {
                src: n,
                alt: C,
                lazyLoad: !0,
                dimensions: {
                  minHeight: "260px",
                  minWidth: "auto"
                },
                className: o.imageContainer
              }
            ),
            /* @__PURE__ */ t(
              M,
              {
                analyticsCompName: _,
                as: "p",
                className: o.paragraph,
                content: d
              }
            ),
            e && !i && /* @__PURE__ */ t(
              J,
              {
                className: o.button,
                analyticsCompName: _,
                href: e.url,
                mobileHref: e.mobileUrl,
                target: e.target,
                type: e.type,
                theme: e.theme,
                text: e.text,
                clickEventName: e.clickEventName,
                ariaLabel: e.ariaLabel,
                mabReward: e.mabReward
              }
            )
          ] })
        ] })
      )
    }
  );
};
Y.requiredProps = {
  headline: !0,
  backgroundColor: !0
};
const Ee = K(Y, fe), Ge = "_card_1kjfi_1", we = "_bgWhite_1kjfi_12", ye = "_cardHeadline_1kjfi_15", Ne = "_container_1kjfi_28", Pe = "_cardParagraph_1kjfi_36", ve = "_cardItemRow_1kjfi_48", m = {
  card: Ge,
  bgWhite: we,
  cardHeadline: ye,
  container: Ne,
  cardParagraph: Pe,
  cardItemRow: ve
}, x = "Card", Me = (r, s, n, C) => {
  const l = {
    headline: n,
    paragraph: C,
    backgroundColor: f.White,
    imageUrl: "",
    imageAltText: "",
    headlineTagName: "h2"
  };
  return r ? [l, ...s] : s;
}, W = ({
  className: r = "",
  collection: s = [],
  headline: n,
  imagePosition: C = w.Left,
  paragraph: l,
  theme: d = a.SMB,
  ...e
}) => {
  const R = C === w.Left, _ = !!n || !!l, c = s.length < 6, k = [
    a["SMB grid"],
    a["SMB grid grey"],
    a.SecurityCenter
  ].includes(d), I = d === a.SecurityCenter, h = k && c, b = Me(
    h,
    s,
    n,
    l
  ), u = `${d}${x}`;
  return /* @__PURE__ */ p(
    "section",
    {
      ...e,
      className: S(
        m.card,
        { [m.bgWhite]: I },
        r
      ),
      children: [
        !h && _ && /* @__PURE__ */ t(y, { className: m.container, as: "div", children: /* @__PURE__ */ t(N, { children: /* @__PURE__ */ p(L, { xs: 12, lg: 8, children: [
          /* @__PURE__ */ t(v, { className: m.cardHeadline, as: "h2", children: n }),
          /* @__PURE__ */ t(
            M,
            {
              analyticsCompName: u,
              className: m.cardParagraph,
              as: "p",
              content: l
            }
          )
        ] }) }) }),
        /* @__PURE__ */ t(y, { as: "div", children: /* @__PURE__ */ t(N, { className: m.cardItemRow, children: b.map((i, B) => /* @__PURE__ */ F(
          Ee,
          {
            ...i,
            key: `CardItem${B + 1}`,
            leftPosition: R,
            theme: d,
            isGridV2: !c,
            analyticsCompName: u
          }
        )) }) })
      ]
    }
  );
};
W.requiredProps = {
  collection: !0,
  imagePosition: !0,
  theme: !0
};
W.displayName = x;
export {
  W as default
};
//# sourceMappingURL=CardsType.js.map
